import React from 'react';
import ReactDOM from 'react-dom';  // Using react-dom without /client
import App from './App';           // Import your main App component

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')  // Select the root element to mount the app
);